import React, { useEffect, useCallback, useState } from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, Button, Text } from '@pancakeswap-libs/uikit'
import { useWeb3React } from '@web3-react/core'
import { useGetStats } from '../../../hooks/api'




const NFTDetailCard = styled(Card)`
  background-image: url('/images/home_lottery_bg.png');
  background-repeat: no-repeat;
  background-position: left center;
  min-height: 340px;
`

const Block = styled.div`
  margin-bottom: 16px;
`

const CardImage = styled.img`
  margin-bottom: 16px;
`

const Label = styled.div`
  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 14px;
`

const Actions = styled.div`
  margin-top: 24px;
`

const FarmedStakingCard = () => {
  const data = useGetStats()
  let lotteryPrice = "";
  if(data){
    lotteryPrice = data;
  }console.log(lotteryPrice,"lotteryPrice")


  return (
    <NFTDetailCard className="white_box home_lottery_box">
      <CardBody>
        <div className="row">
          <div className="col-md-8">
            {/* <img src="/images/home_lottery_bg.png" alt="Icon" style={{marginLeft:"8px"}} /> */}
          </div>
          <div className="col-md-4">
            <div className="home_lottery_box_right">
              <h3>lottery</h3>
              <h1>{lotteryPrice}</h1>
              <p>in KUKU prizes this round</p>
              <hr className="custom_hr"/>
              <p>Buy tickets with KUKU, win KUKU if your numbers match</p>
              <a href="https://nft.pankuku.net/lottery/"><Button>Buy Tickets</Button></a>
            </div>
          </div>
        </div>
      </CardBody>
    </NFTDetailCard>
  )
}

export default FarmedStakingCard
